import * as ActionTypes from "../constants/action-types";
import { pl } from "date-fns/locale";


export function fetchAccountType(payload){
    return function(dispatch) {              
        return fetch(process.env.REACT_APP_API_ENDPOINT + "/EForm/Pre/GetAccountType", { 
            method: 'POST',            
            body: JSON.stringify(payload),
            cache: 'no-cache',
            credentials: 'same-origin',
            headers :{
                'Content-Type':'application/json'
            }
        }).then(response => response.json())
          .then(json => {
              dispatch({ type: ActionTypes.GET_ACCOUNT_TYPE, payload:json });
        });
    };
}

export function fetchCaptcha(){
    return function(dispatch) {
        return fetch(process.env.REACT_APP_API_ENDPOINT + "/EForm/Pre/Captcha/", { 
            method: 'GET',                      
            cache: 'no-cache',
            credentials: 'same-origin',
            headers :{
                'Content-Type':'application/json'
            }
        }).then(response => response.json())
          .then(json => {
              dispatch({ type: ActionTypes.GET_CAPTCHA, payload:json });
        });
    };
}

export function fetchCountryList(payload){
    return function(dispatch) {              
        return fetch(process.env.REACT_APP_API_ENDPOINT + "/EForm/Pre/GetCountryList/", { 
            method: 'POST',            
            body: JSON.stringify(payload),
            cache: 'no-cache',
            credentials: 'same-origin',
            headers :{
                'Content-Type':'application/json'
            }
        }).then(response => response.json())
          .then(json => {
              dispatch({ type: ActionTypes.GET_COUNTRY_LIST, payload:json });
        });
    };
    
}


export function submitHKIDR(payload) {    
    return function(dispatch) {              
        
        return fetch(process.env.REACT_APP_API_ENDPOINT + "/EForm/Pre/Submit/", { 
            method: 'POST',            
            body: JSON.stringify(payload),
            cache: 'no-cache',
            credentials: 'same-origin',
            headers :{
                'Content-Type':'application/json'
            }
        }).then(response => response.json())
          .then(json => {
              dispatch({ type: ActionTypes.SUBMIT_HKIDR, payload: json });
        });
    };
}  

export function verifyAccount(payload){
    return function(dispatch) {              
        
        return fetch(process.env.REACT_APP_API_ENDPOINT + "/EForm/Pre/VerifyAccount/", { 
            method: 'POST',            
            body: JSON.stringify(payload),
            cache: 'no-cache',
            credentials: 'same-origin',
            headers :{
                'Content-Type':'application/json'
            }
        }).then(response => response.json())
          .then(json => {
              dispatch({ type: ActionTypes.VERIFY_ACCOUNT, payload: json });
        });
    };
}

export function fetchConsentStatus(payload){
    return function(dispatch) {              
        return fetch(process.env.REACT_APP_API_ENDPOINT + "/EForm/Pre/GetConsentStatus/", { 
            method: 'POST',            
            body: JSON.stringify(payload),
            cache: 'no-cache',
            credentials: 'same-origin',
            headers :{
                'Content-Type':'application/json'
            }
        }).then(response => response.json())
          .then(json => {              
              dispatch({ type: ActionTypes.GET_CONSENT_STATUS, payload:json });
        });
    };
    
}

export function fetchAccountInfo(payload){
    return function(dispatch) {
        return fetch(process.env.REACT_APP_API_ENDPOINT + "/Eform/Pre/GetAccountInfo/", { 
            method: 'POST',            
            body: JSON.stringify(payload),
            cache: 'no-cache',
            credentials: 'same-origin',
            headers :{
                'Content-Type':'application/json'
            }
        }).then(response => response.json())
          .then(json => {
              dispatch({ type: ActionTypes.GET_ACCOUNT_INFO, payload:json });
        });
    };
}